var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5228 47.9893C25.8865 47.9893 25.2502 47.7549 24.7479 47.2526C23.7767 46.2814 23.7767 44.674 24.7479 43.7028L43.7023 24.7484C44.6735 23.7772 46.2809 23.7772 47.2521 24.7484C48.2232 25.7196 48.2232 27.327 47.2521 28.2982L28.2977 47.2526C27.8288 47.7549 27.1591 47.9893 26.5228 47.9893Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4772 47.9893C44.8409 47.9893 44.2046 47.7549 43.7023 47.2526L24.7479 28.2982C23.7767 27.327 23.7767 25.7196 24.7479 24.7484C25.7191 23.7772 27.3265 23.7772 28.2977 24.7484L47.2521 43.7028C48.2232 44.674 48.2232 46.2814 47.2521 47.2526C46.7498 47.7549 46.1135 47.9893 45.4772 47.9893Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0465 72H25.9535C7.7693 72 0 64.2307 0 46.0465V25.9535C0 7.7693 7.7693 0 25.9535 0H46.0465C64.2307 0 72 7.7693 72 25.9535V46.0465C72 64.2307 64.2307 72 46.0465 72ZM25.9535 5.02326C10.5153 5.02326 5.02326 10.5153 5.02326 25.9535V46.0465C5.02326 61.4846 10.5153 66.9767 25.9535 66.9767H46.0465C61.4846 66.9767 66.9767 61.4846 66.9767 46.0465V25.9535C66.9767 10.5153 61.4846 5.02326 46.0465 5.02326H25.9535Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.007bfeabf446a5c57fc8245a7fce05b4.svg";
export { ForwardRef as ReactComponent };